import { Component } from "react";
import { Modal } from "react-bootstrap";
import UBXButton from "../../ubx/button";

export default class DraftDeDuplicationModal extends Component {
    handleHide() {
        const { onClose } = this.props;
        onClose && onClose();
    }

    handleExistingDraft() {
        const { onExistingDraftClick } = this.props;
        onExistingDraftClick && onExistingDraftClick();
    }

    handleNewApplication() {
        const { onNewApplicationClick } = this.props;
        onNewApplicationClick && onNewApplicationClick();
    }

    render() {
        const { show, productName = "" } = this.props;

        return (
            <Modal id="draft-dedup-modal" show={show} backdrop="static" centered onHide={() => this.handleHide()}>
                <Modal.Header closeButton closeLabel="Close Draft Deduplication Modal"></Modal.Header>
                <Modal.Body>
                    <h2>You have an existing draft application{productName && ` for ${productName}`}</h2>
                    <p>Would you like to create a new one, or continue with the one you currently have?</p>
                    <div className="actions">
                        <UBXButton type="outlined" block={true} onClick={() => this.handleExistingDraft()}>
                            Use Existing Draft
                        </UBXButton>
                        <UBXButton type="primary" block={true} onClick={() => this.handleNewApplication()}>
                            Create New Application
                        </UBXButton>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
